import {
  createMemoryHistory,
  createRouter,
  createWebHistory
} from 'vue-router';
import { getStore } from '@core/store';
import Commons from '../../features/shared/libraries/commons';

let initialUrl = null;
class AppRouter {
  constructor() {
    this.routeModules = this.loadRouteModules();
    this.routes = this.extractRoutes(this.routeModules);
    this.router = this.createVueRouter(this.routes);
    this.setupGuards();
    this.findInitialUrl();
  }

  loadRouteModules() {
    return import.meta.glob('/src/app/features/**/routes.js', { eager: true });
  }

  extractRoutes(modules) {
    if (!modules) return [];
    return Object.values(modules).flatMap((mod) => mod?.default || mod);
  }

  createVueRouter(routes) {
    return createRouter({
      history: createWebHistory(),
      routes: routes,
      scrollBehavior(to, from, savedPosition) {
        // Scroll to top on navigation
        if (savedPosition) {
          return savedPosition;
        } else {
          return { top: 0, behavior: 'smooth' };
        }
      }
      // Wildcard redirect retiré - causait une boucle infinie
    });
  }

  setupGuards() {
    this.router.beforeEach(this.handleNavigation.bind(this));
  }

  handleNavigation(destination, origin, next) {
    this.setPageHeaderColor(destination);
    // this.setRoutePath(destination, origin); // Désactivé - cause une boucle infinie avec vue-router

    if (!this.requiresAuth(destination)) {
      next();
      return;
    }

    if (this.isUserLoggedIn()) {
      next();
    } else {
      next('/login');
    }
  }

  setPageHeaderColor(destination) {
    try {
      Commons.setThemeColor(destination?.meta?.headerColor);
    } catch (error) {
      console.log('🚀 ~ AppRouter ~ setPageHeaderColor ~ error:', error);
    }
  }

  setRoutePath(destination, origin) {
    try {
      const currentPath =
        window.location.pathname +
        window.location.search +
        window.location.hash;
      if (window.programaticBackCalled) {
        window.programaticBackCalled = false;
        window.history.replaceState(
          { date: Date.now() },
          null,
          destination.fullPath
        );
        console.log('replaced from route');

        return;
      }
      if (currentPath == destination.fullPath) return;
      window.history.pushState(
        { date: Date.now() },
        null,
        destination.fullPath
      );
      console.log('pushed from route');
    } catch (error) {
      console.log('🚀 ~ AppRouter ~ setRoutePath ~ error:', error);
    }
  }

  setPageHeaderColor(destination) {
    try {
      Commons.setThemeColor(destination?.meta?.headerColor);
    } catch (error) {
      console.log('🚀 ~ AppRouter ~ setPageHeaderColor ~ error:', error);
    }
  }

  requiresAuth(destination) {
    return Boolean(destination?.meta?.requiresAuth);
  }

  isUserLoggedIn() {
    const userStore = getStore('user');
    return Boolean(userStore?.state?.isLoggedIn);
  }
  findInitialUrl() {
    try {
      if (typeof window === 'undefined') return;
    } catch (error) {
      console.log('🚀 ~ AppRouter ~ findInitialUrl ~ error:', error);
      return;
    }

    initialUrl =
      window.location.pathname + window.location.search + window.location.hash;
  }

  static makeInitialNaviation() {
    try {
      if (initialUrl && typeof initialUrl === 'string') {
        window.$router.replace(initialUrl);
      } else {
        window.$router.replace('/');
      }
    } catch (error) {
      console.error('Initial navigation error:', error);
    }
  }

  get instance() {
    return this.router;
  }
}

function createAppRouter() {
  const appRouter = new AppRouter();
  const router = appRouter.instance;

  if (typeof window !== 'undefined') {
    window.$router = router;
  }

  return router;
}

export { AppRouter, createAppRouter };
